import { Box, Card, Flex, SimpleGrid, Text } from "@mantine/core";
import {
  IconClipboardText,
  IconClock,
  IconMicrophone,
  IconPigMoney
} from "@tabler/icons-react";
import { addCharacterS } from "../../utils/utils";

/* eslint-disable @typescript-eslint/no-explicit-any */
interface userStatsProps {
  amplifyUser: any;
  showHeader?: boolean;
}
const UserStats = ({ amplifyUser, showHeader = true }: userStatsProps) => {
  return (
    <SimpleGrid
      cols={{ base: 1, sm: 4 }}
      mt={showHeader ? 50 : 0}
      className="user-stats"
    >
      <Card ta={"center"} shadow="md" withBorder radius={5}>
        <Flex justify={"space-between"}>
          <Flex justify={"center"} align={"flex-start"} direction={"column"}>
            <Box>
              {amplifyUser !== null && (
                <Text className="title-stats">
                  hour{addCharacterS(amplifyUser.transcriptionTime)} saved
                </Text>
              )}
            </Box>
            <Box>
              <Text ta="center" fz="35" c={"#003554"} fw={800}>
                {amplifyUser === null
                  ? 0
                  : Math.round(
                      (amplifyUser.transcriptionTime / 3600) * 2.5 * 10
                    ) / 10}
              </Text>
            </Box>
          </Flex>
          <IconClock size={48} color="#003554" stroke={1.5} />
        </Flex>
      </Card>
      <Card ta={"center"} shadow="md" withBorder radius={5}>
        <Flex justify={"space-between"}>
          <Flex justify={"center"} align={"flex-start"} direction={"column"}>
            <Box>
              {amplifyUser !== null && (
                <Text className="title-stats">
                  minute{addCharacterS(amplifyUser.transcriptionTime)}
                  <br />
                  transcribed
                </Text>
              )}
            </Box>
            <Box>
              <Text ta="center" fz="35" c={"#003554"} fw={800}>
                {amplifyUser === null
                  ? 0
                  : Math.round(amplifyUser.transcriptionTime / 60)}
              </Text>
            </Box>
          </Flex>
          <IconMicrophone size={48} color="#003554" stroke={1.5} />
        </Flex>
      </Card>
      <Card ta={"center"} shadow="md" withBorder radius={5}>
        <Flex justify={"space-between"}>
          <Flex justify={"center"} align={"flex-start"} direction={"column"}>
            <Box>
              {amplifyUser !== null && (
                <Text className="title-stats">
                  case{addCharacterS(amplifyUser.casesCreated)} created
                </Text>
              )}
            </Box>
            <Box>
              <Text ta="center" fz="35" c={"#003554"} fw={800}>
                {amplifyUser === null ? 0 : amplifyUser.casesCreated}
              </Text>
            </Box>
          </Flex>
          <IconClipboardText size={48} color="#003554" stroke={1.5} />
        </Flex>
      </Card>
      <Card ta={"center"} shadow="md" withBorder radius={5}>
        <Flex justify={"space-between"}>
          <Flex justify={"center"} align={"flex-start"} direction={"column"}>
            <Box>
              {amplifyUser !== null && (
                <Text className="title-stats">saved using Manta Classic</Text>
              )}
            </Box>
            <Box>
              <Text ta="center" fz="35" c={"#003554"} fw={800}>
                $
                {amplifyUser === null
                  ? 0
                  : Math.round(
                      (amplifyUser.transcriptionTime / 3600) * 2.5 * 75.3
                    )}
              </Text>
            </Box>
          </Flex>
          <IconPigMoney
            name="piggy-bank-outline"
            color={"#003554"}
            size={48}
            stroke={1.5}
          />
        </Flex>
      </Card>
    </SimpleGrid>
  );
};
export default UserStats;
